module.exports = __webpack_public_path__ + "img/daily_graphics.f6785caf.png";